export const BUTTON_SPACING = 16;

export const CONTROL_HEIGHT = 32;
